import {
  isManagedReturnsObligation,
  isPaidReturnsForSmallBusinessObligation,
} from '@avalara/bat-apps-shared/helpers/obligations/returns';

import { isAvalaraIncludedCustomer, isPaidAvataxObligation } from '@avalara/bat-apps-shared/helpers/obligations/avatax';

import type { Obligation } from 'types/ztb';

import type { ReturnsEligibilityStatus } from '@avalara/types/index';

export const getReturnsEligibility = (obligations: Array<Obligation>): ReturnsEligibilityStatus => {
  const hasReturnsForSmallBusiness = obligations.some(isPaidReturnsForSmallBusinessObligation);
  const hasManagedReturns = obligations.some(isManagedReturnsObligation);
  if (hasReturnsForSmallBusiness || hasManagedReturns) return 'ALREADY_HAS_RETURNS';

  const hasPaidAvatax = obligations.some(isPaidAvataxObligation);
  const isAvalaraIncluded = isAvalaraIncludedCustomer(obligations);
  if (!hasPaidAvatax && !isAvalaraIncluded) return 'NO_PERMANENT_AVATAX';

  return 'ELIGIBLE';
};
